import { MemberAutocomplete } from '../Common';

const MemberAutocompleteWrapper = objProps => {
  return <MemberAutocomplete {...objProps.field} {...objProps} />;
};

export default MemberAutocompleteWrapper;
